import styled from 'styled-components';

export const SizesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${({ theme }) => theme.getFluidSpacing('gap', 'equal', 5)};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 4)};
`;
